// extracted by mini-css-extract-plugin
module.exports = {"Fruits__headline":"Fruits__headline_2maB","Fruits":"Fruits_FCHt","Fruits__title":"Fruits__title_1kij"};